<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-8">
            <h3 class="mt-1">{{ supplier.name }}</h3>

            <div v-if="userHasPerms(['Manage products'])">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'suppliers-edit',
                  params: { id: supplier.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(supplier.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-4">
            <v-lazy-image
              v-if="supplier.image"
              :src="supplier.image"
              class="img-fluid maxHeight200"
            />
          </div>
        </div>
        <table class="table table-sm">
          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">{{ supplier.id }} </table-row>

          <table-row label="Created"
            >{{
              moment(new Date(supplier.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated"
            >{{
              moment(new Date(supplier.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import supplierRepo from "@/api/repos/supplierRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getSupplier();
  },

  data() {
    return {
      loading: false,
      supplier: {},
    };
  },

  methods: {
    async deleteSupplier(id) {
      this.isBusy = true;
      try {
        await supplierRepo.delete(id);
        this.$emit("supplierUpdated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 400) {
           
            this.$root.$bvToast.toast(error.response.data.message, {
              title: "Errors",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }

       
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the supplier.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteSupplier(id) : false))
        .catch((error) => console.log(error));
    },
    async getSupplier() {
      try {
        this.loading = true;
        let { data } = await supplierRepo.get(this.id);
        this.supplier = data.supplier;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
